/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RegistrationDateRangeFilter { 
    /**
     *                    Business object data registration start datetime. The following formats are supported:                   \"yyyy-MM-dd\" eg. 2018-01-21                   \"yyyy-MM-dd'T'HH:mm\" eg. 2015-12-25T00:01                   \"yyyy-MM-dd'T'HH:mmZ\" eg. 2015-12-25T00:01+04:00                   \"yyyy-MM-dd'T'HH:mm:ss\" eg. 2018-02-03T10:00:02                   \"yyyy-MM-dd'T'HH:mm:ssZ\" eg. 2018-02-03T10:00:02+04:00                   \"yyyy-MM-dd HH:mm:ss\" eg. 2018-02-03 10:00:02                   \"yyyy-MM-dd HH:mm:ssZ\" eg. 2018-03-03 10:00:02+05:30                
     */
    startRegistrationDate?: Date;
    /**
     *                    Business object data registration end datetime. The following formats are supported:                   \"yyyy-MM-dd\" eg. 2018-01-21                   \"yyyy-MM-dd'T'HH:mm\" eg. 2015-12-25T00:01                   \"yyyy-MM-dd'T'HH:mmZ\" eg. 2015-12-25T00:01+04:00                   \"yyyy-MM-dd'T'HH:mm:ss\" eg. 2018-02-03T10:00:02                   \"yyyy-MM-dd'T'HH:mm:ssZ\" eg. 2018-02-03T10:00:02+04:00                   \"yyyy-MM-dd HH:mm:ss\" eg. 2018-02-03 10:00:02                   \"yyyy-MM-dd HH:mm:ssZ\" eg. 2018-03-03 10:00:02+05:30                
     */
    endRegistrationDate?: Date;
}
